import React from 'react';
import { Grid, Header, Image, Segment } from 'semantic-ui-react';
import styles from './OverviewModuleDescription.module.css';

const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const MedicalModuleDescription: React.FC = () => {
  return (
    <Segment basic id={styles['medicalOverview']}>
      <p className={styles.overviewText}>
        In order to understand how the care system works for seniors, it is important to understand how functional status
        impacts lifestyles and the plans to make for the best quality of life. Being on a higher-level functional status
        allows for more independence, capacity to live in their own home, and a more actively engaged life. While others find the care 
        of nursing homes to be their best choice because caregivers' assistance in everyday tasks improves their daily lives.
      </p>
      <p className={styles.overviewText}>
        Good care involves making a plan with their functional status in mind, and that is the foundation of this AgeReady 
        Medical assessment. Each component is a piece of the core health and medical requirements to curate the best plan of care.
      </p>
      <p className={styles.overviewText}>
        The tasks in this section will help maximize the quality of medical care
        and knowledge that will provide you and your loved ones the best quality of life 
        and boost resiliency to preventable diseases and disabilities.
      </p>
            
      <Segment raised className={styles.segmentObjectives}>   
        <Header className={styles.objectivesGroupHeader} >Objectives </Header>     
        <Grid stackable>
          <Grid.Row columns='equal' stretched className={styles.objectivesItemRow}>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColLeft}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >  
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}Learn2Icon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >LEARN </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Learn how to play a critical role in addressing healthcare with your loved ones in mind. 
                  </Header.Subheader>
                </Header>
              </Segment>    
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColMiddle}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >          
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}LearnIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >UNDERSTAND </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Understand how the medical care system opperates in the U.S., on a national and local level. 
                  </Header.Subheader>
                </Header>
              </Segment>    
            </Grid.Column>
            <Grid.Column stretched className={`${styles.objectivesItemColumn} ${styles.objItemColRight}`} >
              <Segment raised className={styles.objectivesItemWhiteBG} >          
                <Header as='h2' icon className={styles.objectivesItemHeader} >
                  <Segment className={styles.objectivesItemIconAndLabel} >
                    <Image src={`${iconRoute}RoadmapIcon.png`} className={styles.objectivesItemHeaderImgIcon} />
                    <p className={styles.objectivesItemHeaderTitle} >CONSTRUCT </p>
                  </Segment>
                  <Header.Subheader className={styles.objectivesItemSubheader} > 
                    Construct a custom plan for medical care to grow and adapt with your love one. 
                  </Header.Subheader>
                </Header>
              </Segment>    
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Segment>
  );
};

export default MedicalModuleDescription;
